/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export enum ASSISTANT_TABS {
  LANGUAGE = 'LANGUAGE',
  COMPOSE = 'COMPOSE',
  CITATION = 'CITATION',
  CHATBOT = 'CHATBOT',
  INSPECT = 'INSPECT',
}

const initialState = {
  showIcon: false,
  open: false,
  currentTab: ASSISTANT_TABS.COMPOSE,
};

export type AiAssistantState = typeof initialState;

export const aiAssistant = createSlice({
  name: 'aiAssistant',
  initialState,
  reducers: {
    setSowIcon: (state, { payload }: PayloadAction<boolean>) => {
      state.showIcon = payload;
    },
    toggleAssistant: (state, { payload }: PayloadAction<boolean>) => {
      state.open = payload;
      if (payload) {
        state.showIcon = true;
      }
    },
    setCurrentTab: (state, { payload }: PayloadAction<ASSISTANT_TABS>) => {
      state.currentTab = payload;
    },
  },
});
